import React from 'react';

import { Link } from 'ui-kit';

import './styles.scss';

const Agreement = () => {
  return (
    <p className="CheckoutForm_customerFormAgreement">
      By continuing, I agree to The Host Co{' '}
      <Link target="_blank" href="https://www.thehost.co/terms-conditions">
        terms of service
      </Link>{' '}
      and{' '}
      <Link target="_blank" href="https://www.thehost.co/privacy-policy">
        privacy policy
      </Link>
      .
    </p>
  );
};

export default Agreement;
